"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnActions = void 0;
exports.ColumnActions = {
    Tag: 'Tag',
    Description: 'Edit Description',
    QualityWarning: 'Data Quality Warning',
    SensitiveLabels: 'Sensitivity Label',
    CustomLabels: 'More Labels',
};
//# sourceMappingURL=ColumnActions.js.map